<template>
  <div class="home">
    <div class="wrapper">
      <div class="content">
        <img class="logo" src="./../assets/bingo-logo.png" />
        <div class="form-group">
            <h1>Bingo-Code einlösen</h1>
            <input type="text" class="form-control" placeholder="z.B. 3P2FMG5833ZFN" v-model="vouchercode">
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-block" @click='redirect()' :disabled='!vouchercode'>Jetzt zökeln!</button>
          </div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: "app",
    data() {
      return {
        vouchercode: ""
      };
    },
    methods: {
      redirect: function() {
        let self = this;
        this.$router.push('/spieler/' + this.vouchercode); 
      }
    }
  };
</script>

<style>

* {
  box-sizing: border-box;
}

</style>

<style scoped>
.home {
  background-color: #000302;
  background-image: url('../assets/start-bg.jpg');
  background-attachment: fixed;
  background-position: bottom;
  background-size: 100% auto;
  background-repeat: no-repeat;
  font-size: 16px;
  text-align: center;
  width: 100%;
  margin: 0;
  min-height: 100vh;
  overflow: hidden;
}

.logo {
  max-width: 450px;
  margin-bottom: 1.5rem;
}

img {
  max-width: 100%;
}

.wrapper {
  width: 100%;
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  align-items: center;
}

.content {
  max-width: 600px;
}

input {
  display: block;
  width: 100%;
  font-size: 2rem;
  text-align: center;
  border: none;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
}

input:focus {
  outline-color: #e36b07;
}

button {
  display: block;
  width: 100%;
  background-color: #e36b07;
  color: #fff;
  height: 60px;
  font-size: 1.5rem;
  font-weight: bold;
  border: none;
  margin-top: 20px;
  cursor: pointer;
}

.content {
  margin-bottom: 80px;
}

h1 {
  font-size: 1.5em;
}

@media all and (max-width: 700px) {

    .sticky img {
      padding-top: 15px;
      margin-left: 10px;
      margin-right: 10px;
    }

    .logo {
      max-width: 90%;
    }

    .content {
      max-width: 90%;

    }
}
</style>
